import { X } from "@reverb-ui/icons-react";
import { Button, Center, Col, Row, Text, Tooltip } from "@reverb-ui/react";
import { CustomSelect } from "components/AllowFiltering/CustomSelect";
import React from "react";
import {
  TDropOffItem, TSelectOption,
} from "../context-api/DropoffCalculatorProvider";

type TagRowProps = {
  dropOffItem?: TDropOffItem | null;
  position: number;
  dropOffSelectOptions: TSelectOption[];
  onChange: (option: TSelectOption) => void;
  onClickRemove: () => void;
  canRemove?: boolean;
};

const TagRow = ({
  dropOffItem,
  dropOffSelectOptions,
  position,
  onChange,
  onClickRemove,
  canRemove
}: TagRowProps) => {

  return (
    <Row alignItems="center">
      <Col col={7}>
        <Center w="40px" h="40px" backgroundColor="gray.200" marginRight="1rem">
          <Text fontSize="sm" color="black.500" fontWeight="bold" whiteSpace={"nowrap"}>
            #{position + 1}
          </Text>
        </Center>
        <CustomSelect
          options={dropOffSelectOptions || []}
          value={dropOffItem?.selectedOption || null}
          placeholder="Choose a tag"
          onChange={({ value, label }: any) => onChange({value, label})}
        />
      </Col>
      <Col col={2} justifyContent="center">
        <Text textTransform="uppercase" fontSize="sm" fontWeight="semibold">
          {dropOffItem?.tag.quantity || '-'}
        </Text>
      </Col>
      <Col col={2} justifyContent="center">
        <Center>
          <Text textTransform="uppercase" fontSize="sm" fontWeight="semibold">
            {dropOffItem?.dropOffPercentage ? `${dropOffItem.dropOffPercentage}%` : '-'}
          </Text>
        </Center>
      </Col>
      <Col col={1} justifyContent="center">
        {canRemove ? (
          <Button
            color="gray.500"
            textTransform="uppercase"
            fontSize="xs"
            fontWeight="semibold"
            variant="ghost"
            onClick={onClickRemove}
          >
            <X color="gray.500" />
          </Button>
        ) : (
          <Tooltip
            label="You remove this step"
            placement="bottom"
            bg="gray.100"
            color="gray.800"
            shouldWrapChildren
          >
            <Button
              disabled
              color="gray.500"
              textTransform="uppercase"
              fontSize="xs"
              fontWeight="semibold"
              variant="ghost"
            >
              <X color="gray.500" />
            </Button>
          </Tooltip>
        )}
      </Col>
    </Row>
  );
};

export default React.memo(TagRow);
